// Client-side hooks
export const handleError = ({ error }: { error: unknown }) => {
  console.error('Client error:', error);
  return {
    message: 'An unexpected error occurred',
  };
};

export function init(): void | Promise<void> {
  // Optional client init (e.g. for analytics). No-op by default.
}
